module.exports = __webpack_public_path__ + "img/woman_shrugging.f64f922f.gif";